var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('top'),_c('div',{staticClass:"main"},[_c('keep-alive',[_c('router-view',{staticStyle:{"flex":"1"}})],1)],1),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }